import React from 'react';

const Download = (props: any) => {
  return (
    <div className={props.className}>
      <a href={`attachments/PNXClient.exe`} download="谷歌浏览器.exe">PKI下载</a>
    </div>
  )
};

export default Download;
